//是否过期
export function isTimeOverdue(key) {
  let result = true;
  try {
    const value = window.localStorage.getItem(String(key).toUpperCase());
    if (value) {
      const oldTimes = new Date(Number(value));
      const nowTimes = new Date();
      if (typeof oldTimes.FormatDate === 'function') {
        // console.log('nowTimes,oldTimes', nowTimes.FormatDate('yyyyMMdd'), oldTimes.FormatDate('yyyyMMdd'));
        result = nowTimes.FormatDate('yyyyMMdd') >= oldTimes.FormatDate('yyyyMMdd');
      } else {
        result = nowTimes > oldTimes;
      }
    }
  } catch (error) {
    console.log(error);
  }

  return result;
}

// 设置过期
export function setTimeOverdue(key, days) {
  try {
    const date = new Date();
    date.setDate(date.getDate() + (days || 1));
    const value = date.getTime();
    window.localStorage.setItem(String(key).toUpperCase(), value);
  } catch (error) {
    console.log(error);
  }
}

export default {
  isTimeOverdue,
  setTimeOverdue
};
